import * as React from 'react';
import * as MuiIcons from '@mui/icons-material';
import * as PXBColors from '@brightlayer-ui/colors';
import * as PXBCore from '@brightlayer-ui/react-components/core';
import * as MuiCore from '@mui/material';
import { ChannelDetails } from '../../../types';
import { AlarmConfigDrawer } from '../AlarmConfigDrawer/AlarmConfigDrawer';
import { DeviceChannelData } from '../../../types/device';
import { useSelector } from 'react-redux';
import { Selectors } from '../../../selectors';
import { AlarmConfigProvider } from '../../../data/DataProviders/AlarmConfigProvider';
import { DataProviderCache } from '../../../data/DataProviders/DataProviderCache';

export const ManageAlarmsListItem: React.FC<{
    value: DeviceChannelData;
    isLast: boolean;
    onClick?: () => void;
}> = (props) => {
    const [open, setOpen] = React.useState(false);
    //  const [openGlobalModal, setOpenGlobalModal] = React.useState(false);
    const [channelDetails, setChannelDetails] = React.useState<ChannelDetails>({
        name: '',
        devices: [],
        tagId: '',
        type: '',
    });
 //   const [checked, setChecked] = React.useState(false);
    const selectedDevice = useSelector(Selectors.ManageAlarmsSelectors.selectedDevice);
    // const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    //     event.stopPropagation();
    //     setChecked(event.target.checked);
    // };
    const openDrawer = (_open: boolean, _channelDetails: ChannelDetails): void => {
        setOpen(_open);
        setChannelDetails(_channelDetails);
    };
    const closeDrawer = (): void => {
        setOpen(false);
    };
    // const handleCloseGlobalModal = (): void => {
    //     setOpenGlobalModal(false);
    // };
    return (
        <div
            data-testid="device-list-item"
            style={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}
        >
            <PXBCore.InfoListItem
                title=""
                hidePadding={true}
                backgroundColor={PXBColors.white[50]}
                divider={!props.isLast ? 'full' : undefined}
                subtitleSeparator="<"
                iconColor={PXBColors.gray[500]}
                onClick={(): void =>
                    openDrawer(!open, {
                        name: props.value.name || '',
                        tagId: props.value.id,
                        devices: [],
                        type: props.value.type,
                    })
                }
                leftComponent={
                    <div>
                        <MuiCore.Typography variant="body2" display="inline" style={{ lineHeight: 1.25 }}>
                            {props.value.name}
                        </MuiCore.Typography>
                        <MuiCore.Typography
                            variant="body2"
                            display="inline"
                            style={{ marginLeft: '5px', fontWeight: 400, lineHeight: 1.25 }}
                        ></MuiCore.Typography>
                    </div>
                }
                rightComponent={
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {/* <MuiCore.Typography
                            variant="body2"
                            display="inline"
                            style={{
                                fontSize: 10,
                                width: '78px',
                                height: '16px',
                                color: PXBColors.white[50],
                                backgroundColor: PXBColors.yellow[500],
                                fontWeight: 700,
                                lineHeight: '16px',
                                letterSpacing: 1,
                                textAlign: 'center',
                            }}
                        >
                            LO CAUTION
                        </MuiCore.Typography>
                        <MuiCore.Typography
                            variant="body2"
                            display="inline"
                            style={{
                                fontSize: 10,
                                width: '120px',
                                height: '16px',
                                color: PXBColors.blue[500],
                                backgroundColor: PXBColors.blue[100],
                                fontWeight: 700,
                                lineHeight: '16px',
                                letterSpacing: 1,
                                textAlign: 'center',
                            }}
                        >
                            MULTI-CONFIGURED
                        </MuiCore.Typography>
                        <MuiCore.Typography
                            variant="body2"
                            display="inline"
                            style={{
                                fontSize: 10,
                                width: '71px',
                                height: '16px',
                                color: PXBColors.white[50],
                                backgroundColor: PXBColors.red[500],
                                fontWeight: 700,
                                lineHeight: '16px',
                                letterSpacing: 1,
                                textAlign: 'center',
                            }}
                        >
                            HI CRITICAL
                        </MuiCore.Typography> */}
                        {/* <MuiCore.IconButton
                            style={{ marginLeft: 16, color: PXBColors.gray[500] }}
                            onClick={(e: any): void => {
                                // setOpenGlobalModal(true);
                                e.stopPropagation();
                            }}
                        >
                            <MuiIcons.Language />
                        </MuiCore.IconButton> */}

                        {/* <MuiCore.Box>
                            <MuiCore.ListItem style={{ marginLeft: '5px', fontWeight: 600, lineHeight: 1.25 }}>
                                <MuiCore.ListItemSecondaryAction>
                                    <MuiCore.Switch
                                        onChange={handleChange}
                                        onClick={(e: any): void => {
                                            e.stopPropagation();
                                        }}
                                        checked={checked}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                    />
                                </MuiCore.ListItemSecondaryAction>
                            </MuiCore.ListItem>
                        </MuiCore.Box> */}
                        <MuiCore.IconButton style={{ marginLeft: 16 }}>
                            <MuiIcons.ChevronRight />
                        </MuiCore.IconButton>

                        {/* <GlobalAlarmModal
                            open={openGlobalModal}
                            onClose={handleCloseGlobalModal}
                            channelName={props.value.name|| ''}
                        /> */}
                    </div>
                }
            />

            {selectedDevice !== '' && channelDetails.tagId !== '' && (
                <DataProviderCache for="alarm-config-provider">
                    <AlarmConfigProvider deviceId={selectedDevice || ''} channels={channelDetails.tagId.toString()}>
                        <AlarmConfigDrawer
                            key={channelDetails.tagId}
                            deviceId={selectedDevice || ''}
                            open={open}
                            openDrawer={openDrawer}
                            channelDetails={channelDetails}
                            closeDrawer={closeDrawer}
                        ></AlarmConfigDrawer>
                    </AlarmConfigProvider>
                </DataProviderCache>
            )}
        </div>
    );
};
